import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'coin-lantern',
  standalone: true,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size() * 1.67"
      viewBox="0 0 24 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="lanternGlow" cx="50%" cy="45%" r="50%">
          <stop offset="0%" stop-color="#FFD54F" stop-opacity="0.6" />
          <stop offset="50%" stop-color="#D81838" stop-opacity="0.9" />
          <stop offset="100%" stop-color="#D81838" stop-opacity="1" />
        </radialGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <!-- String -->
      <line x1="12" y1="0" x2="12" y2="5" stroke="#C9941A" stroke-width="1" stroke-linecap="round" />
      <!-- Top cap -->
      <rect x="7" y="5" width="10" height="2.5" rx="1" fill="#C9941A" />
      <!-- Body with glow -->
      <ellipse cx="12" cy="18.5" rx="11" ry="12.5" fill="url(#lanternGlow)" filter="url(#glow)" />
      <!-- Center rib -->
      <line x1="12" y1="6" x2="12" y2="30" stroke="#C9941A" stroke-width="0.7" opacity="0.3" />
      <!-- Bottom cap -->
      <rect x="7" y="30" width="10" height="2.5" rx="1" fill="#C9941A" />
      <!-- Tassel -->
      <line x1="10.5" y1="32.5" x2="9.5" y2="38" stroke="#C9941A" stroke-width="0.8" stroke-linecap="round" />
      <line x1="12" y1="32.5" x2="12" y2="39.5" stroke="#C9941A" stroke-width="0.8" stroke-linecap="round" />
      <line x1="13.5" y1="32.5" x2="14.5" y2="38" stroke="#C9941A" stroke-width="0.8" stroke-linecap="round" />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanternComponent {
  size = input<number>(24);
}
